import { NoSSR } from '@ui/components/NoSSR';
import { PercentageSplitLine } from '@ui/components/PercentageSplitLine';
import { StatAmountUsd, StatLabel } from '@ui/components/Stats';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { useTranslation } from 'next-i18next';
import { Box, Flex } from 'styled-system/jsx';

import { useOpenInterest } from '../../../../hooks/trade/useOpenInterest';

export const OpenInterests = () => {
  const { t } = useTranslation();
  const tradingPair = useTradingPair((v) => v.useTradingPair());

  const { longRatio, longOIUsd, shortOIUsd } = useOpenInterest(tradingPair);

  const maxLongOiUsdBuffered = tradingPair.maxLongOiUsdBuffered;
  const maxShortOiUsdBuffered = tradingPair.maxShortOiUsdBuffered;

  return (
    <Box mt={2}>
      <Flex justifyContent="space-between">
        <StatLabel>{t('common.Long Open Interests')}</StatLabel>
        <StatLabel>{t('common.Short Open Interests')}</StatLabel>
      </Flex>
      <NoSSR>
        <PercentageSplitLine
          firstLinePercentage={
            longRatio ? longRatio.multipliedBy(100).toNumber() : 100
          }
          my={1}
        />
      </NoSSR>
      <Flex justifyContent="space-between">
        <Box textStyle="text.small">
          <NoSSR>
            <StatAmountUsd opts={{ kmb: true }} as="span" value={longOIUsd} />
            {' / '}
            <StatAmountUsd as="span" value={maxLongOiUsdBuffered} />
          </NoSSR>
        </Box>
        <Box textStyle="text.small">
          <NoSSR>
            <StatAmountUsd opts={{ kmb: true }} as="span" value={shortOIUsd} />
            {' / '}
            <StatAmountUsd as="span" value={maxShortOiUsdBuffered} />
          </NoSSR>
        </Box>
      </Flex>
    </Box>
  );
};
